import { FC } from "react";
import { ReactComponent as PlusIcon } from "../../../../../../../assets/actions/plus.svg";
import { AiOutlineMinus as RemoveIcon } from "@react-icons/all-files/ai/AiOutlineMinus";
import Cropper from "react-easy-crop";
import { Box, Button, Flex } from "@radix-ui/themes";
import i18next from "i18next";

export const EditWithInitImage: FC<{
  onCropComplete: any;
  zoom: any;
  crop: any;
  profileCroppedImage: any;
  setCrop: any;
  setZoom: any;
}> = ({
  onCropComplete,
  zoom,
  crop,
  profileCroppedImage,
  setCrop,
  setZoom,
}) => {
  const CONTAINER_HEIGHT = 300;
  return (
    <Flex position="relative" direction="column">
      {profileCroppedImage && (
        <Box>
          <Box minHeight="100%" height="300px">
            <Box>
              <Cropper
                image={profileCroppedImage!}
                crop={crop}
                zoom={zoom}
                aspect={1 / 1}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
            </Box>
          </Box>
          <Box>
            <Button
              variant="solid"
              onClick={() => {
                setZoom((prev: any) => {
                  if (prev - 0.1 <= 1) {
                    return prev;
                  }
                  return prev - 0.1;
                });
              }}
              disabled={zoom <= 1}
            >
              <RemoveIcon />
            </Button>

            <Button
              variant="solid"
              onClick={() => {
                setZoom((prev: any) => {
                  if (prev + 0.1 >= 3) {
                    return prev;
                  }
                  return prev + 0.1;
                });
              }}
              disabled={zoom >= 3}
            >
              <PlusIcon />
            </Button>
          </Box>
        </Box>
      )}
    </Flex>
  );
};
